import React, {
  Fragment, useState, useEffect, useRef,
} from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import styles from "./assets/styles.scss";
import LangSwitcher from "./LangSwitcher";
import SideSlider from "../SideSlider/SideSlider";

import IconGames from "../../assets/img/games.svg?inline";
import IconRaces from "./assets/images/races.svg?inline";
import IconSidenav from "./assets/images/side-nav.svg?inline";
import IconPromotions from "./assets/images/promotions.svg?inline";
import IconSlots from "../../assets/img/slots.svg?inline";
import IconTableGames from "../../assets/img/table-games.svg?inline";

const cx = classNames.bind(styles);

export default function SideNav({ reverse }) {
  const sideNavRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [langSwitcherOpen, setLangSwitcherOpen] = useState(false);
  const hasAffiliateStatus = useSelector(state => !!state.affiliate.status);

  const navItems = [
    { label: "Peergame Partners", to: hasAffiliateStatus ? "/partners/dashboard" : "/partners" },
    { label: "Blog", href: "https://blog.peergame.com" },
    { label: "Fairness", to: "/provably-fair" },
    { label: "Help Center", href: "https://help.peergame.com/" },
    { label: "Contact", href: "mailto:contact@peergame.com" },
  ];

  useEffect(() => {
    if (!isOpen) {
      setLangSwitcherOpen(false);
    }
  }, [isOpen]);

  return (
    <Fragment>
      <button
        className={cx("header-button", { reverse })}
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Sidebar"
      >
        <IconSidenav />
      </button>
      <SideSlider
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        ref={sideNavRef}
        className={cx("sidenav", { reverse })}
      >
        <div className={cx("section")}>
          <Link to="/games" className={cx({ reverse })}>
            <IconGames />
            Games
          </Link>
          <Link to="/games?category=slots" className={cx({ reverse })}>
            <IconSlots />
            Slots
          </Link>
          <Link to="/games?category=table" className={cx({ reverse })}>
            <IconTableGames />
            Table Games
          </Link>
          <Link to="/races" className={cx({ reverse })}>
            <IconRaces />
            Races
          </Link>
          <a href="https://promotions.peergame.com/" className={cx({ reverse })}>
            <IconPromotions />
            Promotions
          </a>
        </div>
        <div className={cx("divider")} />
        <div className={cx("section")}>
          {navItems.map(({ to, href, label }) => to ? (
            <Link className={cx({ reverse })} key={label} to={to}>
              {label}
            </Link>
          ) : (
            <a className={cx({ reverse })} key={label} href={href} target="_blank" rel="noopener noreferrer">
              {label}
            </a>
          ))}
          <LangSwitcher
            isOpen={langSwitcherOpen}
            toggleOpen={() => setLangSwitcherOpen(!langSwitcherOpen)}
            reverse={reverse}
            onOpened={() => sideNavRef.current.scrollTo({ top: 9999, behavior: "smooth" })}
          />
        </div>
      </SideSlider>
    </Fragment>
  );
}
SideNav.propTypes = {
  reverse: PropTypes.bool,
};
SideNav.defaultProps = {
  reverse: false,
};
